<template>
    <div class="lookPopup">
        <el-input v-model="currentValue" placeholder="请选择" 
            @click.native="onClick"
            suffix-icon="el-icon-search" readonly
        >
        </el-input>
        <div  class="lookPopup-table">
            <DialogEx :options="dialogConfig.viewConfig" :title="dataTitle" @onOk="onConfirmOk">
                <fixed-list :dataSource="dataSource" @onDataSourceChange="onDataSourceChange" @onPageChange="initialize" :queryParam="queryParam" :custShowQueryOptions="custShowQueryOptions">
                    <el-table ref="list" slot="elList" :data="dataSource.Result" border @selection-change="handleSelectionChange" @current-change="handleCurrentChange" highlight-current-row>
                        <el-table-column v-for="(col,index)  in (dataSource.ColDefs&&dataSource.ColDefs.BodyFieldParams)"
                            :key="index"
                            :prop="col.FieldName"
                            :label="col.DisplayName"
                            :render-header="bindFilter(queryParam,col)"
                            :fixed="index==0"
                            :min-width="parseInt(col.Width)"
                            v-if="col.Visible">
                        </el-table-column>
                    </el-table>
                </fixed-list>
            </DialogEx>
        </div>
        
    </div>
</template>
<script>
    export default {
        name: 'LookPopup',
        model: { prop: 'currentValue' },
        data: function () {
            return {
                dialogConfig: {
                    viewConfig:{
                        visible: false,
                        size: 'small'
                    }
                },
                queryParam: {
                    PageIndex: 1,
                    PageSize: 10,
                    Params: {}
                },
                dataSource: {
                    ColDefs: {
                        BodyFieldParams:[]
                    },
                    Result: [],
                    TotalCount: 0
                },
                selectedRow:{},
                selectedRows: [],
                multipleSelection: [],
            }
        },
        props: {
            currentValue:{
                type: String,
                default: ''
            },
            dataTitle:{
                type: String,
                default: '数据选择'
            },
            dataMethod:{
                type: String,
                default: 'post'
            },
            dataUrl:{
                type: String,
                default: ''
            },
            dataOptions:{
                type:Object,
                default:()=>({})
            },
            syncField:{
                type: String,
                default: ''
            },
            isRequired: { // 是否必填
                type: Boolean,
                default: true
            },
            onChange: { // 变化事件
                type: Function,
                default: null
            },
            readonly: { // 只读
                type: Boolean,
                default: false
            },
            emptyValue: { // 值为空时显示的字符串
                type: String,
                default: '------'
            },
            custShowQueryOptions:{
                type: Boolean,
                default: true
            }
        },
        mounted: function () {
            this.initialize();
        },
        beforeDestroy() {
            /*页面销毁的时候要保存一些数据，就可以监听这个销毁的生命周期函数*/
        },
        watch: {
        },
        computed: {
        },
        methods: {
            onClick(){
                console.log(1)
                this.dialogConfig.viewConfig.visible = true;
				if( this.$listeners.syncClickEvent){
					this.$emit('syncClickEvent',this.dialogConfig.viewConfig);
				}else{
				  this.initialize();
				}
				
            },
            onShopSelectedRow: function (row) {
                this.currentShopSelectedRow = row;
            },
            onConfirmOk(){
                if(this.selectedRow){
                    this.$emit("input", this.selectedRow[this.syncField]);
                    this.$emit('syncFieldEvent', this.selectedRow);
                }
            },
            handleCurrentChange: function (row) {
                this.selectedRow = row;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            onDataSourceChange(ds) {
                var _this = this;
                // _this.dataSource = {
                //     ColDefs: {
                //         BodyFieldParams: []
                //     },
                //     Result: [],
                //     TotalCount: 0
                // };
                // _this.$nextTick(function () {
                //     _this.dataSource = ds;
                // });
            },
            initialize() { 
                let _this = this;
                if(_this.dataOptions!=null && Object.keys(_this.dataOptions).length>0){
                    Object.keys(_this.dataOptions).forEach(key => {
					    var val = _this.dataOptions[key];
                        _this.queryParam.Params[key]=val;
                    });
                }
                if (_this.selectCondition) {
                    _this.Utils.extend(_this.queryParam.Params, _this.selectCondition);
                }
                 var dataUrl= this.dataUrl;
                 var method = this.dataMethod;
                _this.$ajax.query(dataUrl, method, _this.queryParam, (data) => {
                    if(data.IsSuccess){
                        _this.dataSource = data;
                    }
                }, null, false);
            }
        }
    }
</script>